(function () {
  if (window.breeqFormatMoney) return;

  const DEFAULT_CURRENCY_DECIMALS = 2;

  const CURRENCY_DECIMALS = {
    BHD: 3,
    BIF: 0,
    BYR: 0,
    CLF: 4,
    CLP: 0,
    DJF: 0,
    GNF: 0,
    IQD: 3,
    ISK: 0,
    JOD: 3,
    JPY: 0,
    KMF: 0,
    KRW: 0,
    KWD: 3,
    LYD: 3,
    MRO: 5,
    OMR: 3,
    PYG: 0,
    RWF: 0,
    TND: 3,
    UGX: 0,
    UYI: 0,
    UYW: 4,
    VND: 0,
    VUV: 0,
    XAF: 0,
    XAG: 0,
    XAU: 0,
    XBA: 0,
    XBB: 0,
    XBC: 0,
    XBD: 0,
    XDR: 0,
    XOF: 0,
    XPD: 0,
    XPF: 0,
    XPT: 0,
    XSU: 0,
    XTS: 0,
    XUA: 0,
  };

  function getCurrencyPrecision(currency) {
    return CURRENCY_DECIMALS[String(currency).toUpperCase()] ?? DEFAULT_CURRENCY_DECIMALS;
  }

  function getCurrencyDivisor(currency) {
    return Math.pow(10, getCurrencyPrecision(currency));
  }

  function formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision, divisor) {
    const roundedNumber = (moneyValue / divisor).toFixed(precision);

    let [a, b] = roundedNumber.split('.');
    if (!a) a = '0';
    if (!b) b = '';

    a = a.replace(/\d(?=(\d\d\d)+(?!\d))/g, (digit) => digit + thousandsSeparator);

    return precision <= 0 ? a : a + decimalSeparator + b.padEnd(precision, '0');
  }

  function formatMoney(moneyValue, format, currency) {
    const currencyPrecision = getCurrencyPrecision(currency);
    const divisor = getCurrencyDivisor(currency);

    return String(format).replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
      if (typeof placeholder !== 'string') return '';
      if (placeholder === 'currency') return currency;

      let thousandsSeparator = ',';
      let decimalSeparator = '.';
      let precision = currencyPrecision;

      switch (placeholder) {
        case 'amount':
          break;
        case 'amount_no_decimals':
          precision = 0;
          break;
        case 'amount_with_comma_separator':
          thousandsSeparator = '.';
          decimalSeparator = ',';
          break;
        case 'amount_no_decimals_with_comma_separator':
          thousandsSeparator = '.';
          precision = 0;
          break;
        case 'amount_no_decimals_with_space_separator':
          thousandsSeparator = ' ';
          precision = 0;
          break;
        case 'amount_with_space_separator':
          thousandsSeparator = ' ';
          decimalSeparator = ',';
          break;
        case 'amount_with_period_and_space_separator':
          thousandsSeparator = ' ';
          decimalSeparator = '.';
          break;
        case 'amount_with_apostrophe_separator':
          thousandsSeparator = "'";
          decimalSeparator = '.';
          break;
        default:
          break;
      }

      return formatCents(moneyValue, thousandsSeparator, decimalSeparator, precision, divisor);
    });
  }

  window.breeqFormatMoney = function (cents) {
    const config = window.breeqMoney || {};
    return formatMoney(Math.ceil(cents), config.format || '{{amount}}', config.currency || 'EUR');
  };

  window.breeqFormatMoneyWith = formatMoney;
})();
